import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const FiltrosContainer = styled(Box)`
    width: 100%;
    margin: 1rem auto 0;
    display: flex;
`